<template>
  <responsive-drawer-layout>
    <template v-slot:drawer>
      <messaging-drawer v-if="firstRenderingComplete" @onReceiverSelected="onReceiverSelected" :displayConversations="displayConversations"></messaging-drawer>
      <div v-else>..</div>
    </template>

    <template v-slot:content>
      <div :class="`messages-container-${themeName}`" class="inherit-height d-flex flex-column">
        <div class="d-flex flex-column pl-5 pt-8 messages" ref="messages">
          <div ref="messagesContainer">
            <div v-if="selectedChatMessages.totalMessagesCount > 0 && firstRenderingComplete">
              <message v-for="(message, index) in messages" :key="index" :message="message" :addressee="selectedReceiver"></message>
            </div>

            <!-- This is the container to display an uploaded image before sending -->
            <div v-if="chosenImageBase64" class="d-flex elevation-5 flex-column ml-auto mt-3 pa-3" style="max-width: 90%">
              <div class="red lighten-4 py-1 px-3">{{ $t('messaging.notSentYet') }}</div>
              <v-img cover style="border-radius: 8px; overflow: hidden; max-height: 50vh" :lazy-src="chosenImageBase64"></v-img>
            </div>

            <div
              v-if="chosenFile && chosenFileUrl"
              class="d-flex elevation-5 flex-column ml-auto mt-3"
              style="max-width: 90%; border-radius: 8px; overflow: hidden"
            >
              <div class="blue lighten-4 py-1 px-3 d-flex justify-space-between align-center">
                <span class="font-weight-bold" style="font-size: 0.9em">
                  <v-icon left>mdi-file</v-icon>
                  {{ chosenFile.name }}
                </span>
                <v-btn icon small @click="clearChosenFile">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <div class="pa-4 d-flex align-center white">
                <v-icon x-large color="red">mdi-file-pdf-box</v-icon>
                <div class="ml-2">
                  <div class="body-2 font-weight-bold">{{ chosenFile.name }}</div>
                  <div class="caption grey--text">{{ (chosenFile.size / 1024).toFixed(1) }} KB</div>
                </div>
              </div>
            </div>

            <!-- marker element to scroll to the bottom -->
            <div ref="lastDivider" style="width: 100%; height: 2px"></div>
          </div>
          <empty-state-indicator v-if="selectedChatMessages.totalMessagesCount === 0" icon="mdi-message-bulleted-off" :text="$t('messaging.noMessages')" />
        </div>
        <!-- Camera icon, Text Field, Send Button -->
        <!-- <div v-if="selectedReceiver" class="d-flex pt-2 py-0" style="height: 54px"> -->
        <div v-if="selectedReceiver" class="d-flex pt-2 py-0" style="height: fit-content">
          <div style="display: flex; flex-direction: column; margin-bottom: 0.4em">
            <v-btn
              v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.cameraOnly"
              icon
              :disabled="!canUserReceiveMessage"
              @click="onCameraClick"
              class="mx-2"
            >
              <v-icon>mdi-camera</v-icon>
            </v-btn>
            <v-btn
              v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.galleryOnly"
              :disabled="!canUserReceiveMessage"
              icon
              @click="onImageClick"
              class="mx-2"
            >
              <v-icon>mdi-image</v-icon>
            </v-btn>
            <v-btn icon :disabled="!canUserReceiveMessage" @click="onAttachmentClick" class="mx-2">
              <v-icon>mdi-paperclip</v-icon>
            </v-btn>
          </div>
          <!-- Hidden image picker -->
          <v-file-input
            v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.cameraOnly"
            :disabled="!canUserReceiveMessage"
            v-show="false"
            capture="user"
            prepend-icon="mdi-camera"
            hide-input
            hide-details
            ref="cameraPicker"
            id="cameraPicker"
            v-model="chosenImage"
            accept="image/*"
            @change="onPickImage"
            class="hidden"
          />
          <v-file-input
            v-if="mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.galleryOnly"
            v-show="false"
            :disabled="!canUserReceiveMessage"
            prepend-icon="mdi-image"
            hide-input
            hide-details
            ref="imagePicker"
            id="imagePicker"
            v-model="chosenImage"
            accept="image/*"
            @change="onPickImage"
            class="hidden"
          />
          <v-file-input
            v-show="false"
            :disabled="!canUserReceiveMessage"
            prepend-icon="mdi-paperclip"
            hide-input
            hide-details
            ref="attachmentPicker"
            id="attachmentPicker"
            v-model="chosenFile"
            accept="application/pdf"
            @change="onPickAttachment"
            class="hidden"
          />

          <!-- <div style="width:40px !important">
         
          </div> -->
          <!-- v-on:keyup.enter="sendMessage" -->
          <!-- seems to be unnecessary   v-on:eydown.enter.shift.exact.prevent="message += '\n'" -->
          <!-- On mobile devices the enter soft-key needs to create a new line -->
          <v-textarea
            v-model="message"
            :label="chosenImageBase64 ? $t('writeACaption') : $t('writeAMessage')"
            v-on:keydown.shift.enter.exact.prevent="sendMessage"
            filled
            rows="1"
            color="accent"
            outlined
            hide-details
            rounded
            denseaa
            clearable
            auto-grow
            :disabled="!canUserReceiveMessage"
            class="message-input d-flex flex-grow px-1 mb-2"
          ></v-textarea>

          <v-btn
            class="mr-3"
            @click="sendMessage"
            icon
            :disabled="!(message || chosenImageBase64 || chosenFile) || !canUserReceiveMessage"
            :color="message || chosenImageBase64 || chosenFile ? 'error' : ''"
          >
            <v-icon>mdi-send</v-icon>
          </v-btn>
          <!-- :style="`transition:1s all;opacity:${message || chosenImageBase64 ? 1 : 0};padding-right:20px;width:${message || chosenImageBase64? '50px' : '0'}`" -->
        </div>
      </div>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import common from '@/mixins/common';
import Message from './Message.vue';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import MessagingDrawer from './MessagingDrawer.vue';
import { preprocessImage } from '../../common/mediaUtils';
import messagingUtil from './messagingUtil';
import EmptyStateIndicator from '@/components/container/EmptyStateIndicator.vue';
import configMixin from '@/mixins/configMixin';

export default {
  name: 'Chat',
  mixins: [common, configMixin],
  components: {
    Message,
    ResponsiveDrawerLayout,
    MessagingDrawer,
    EmptyStateIndicator,
  },
  mounted() {
    let messagesInnerContainer = this.$refs.messagesContainer;

    // Observe scroll container and scroll lastDivider element into view when changed (that is new elements added)
    new ResizeObserver(() => {
      // let lastDivider = this.$refs.lastDivider;
      // let firstDivider = this.$refs.firstDivider;
      // if (lastDivider) {
      //   if (this.scrollToLatest) {
      //     lastDivider.scrollIntoView();
      //   } else {
      //     firstDivider.scrollIntoView({ behavior: 'smooth' });
      //   }
      // }
    }).observe(messagesInnerContainer);

    this.mx_isLeftDrawerOpen = this.dataLoaded && this.selectedReceiver == null;
    setTimeout(() => {
      this.firstRenderingComplete = true;
    }, 100);

    this.markAsReadAfterTimeout(this.messages);

    if (this.messages.length) {
      this.scrollToLatestMessage(100);
    }
  },
  data() {
    return {
      galleryCameraSwitchEnabled: true, // for the time being this is a local flag, to enable the user to switch between camera and gallery. Might be configurable in future by tenant / usage
      message: null,
      chosenImage: null,
      chosenImageBase64: null,
      chosenFile: null,
      chosenFileUrl: null,
      scrollToLatest: true,
      firstRenderingComplete: false,
      displayConversations: true,
    };
  },
  computed: {
    ...mapState('messaging', ['messages', 'messagesByUserId', 'messagesByGroupId', 'dataLoaded', 'userId']),
    /**
     * Gets the messages of the currently selected chat
     */
    selectedChatMessages() {
      let selectedChatMessages = [];
      if (this.selectedReceiver) {
        selectedChatMessages = this.selectedReceiver.userId
          ? this.messagesByUserId[this.selectedReceiver.userId]
          : this.messagesByGroupId[this.selectedReceiver.groupId];
      }
      if (selectedChatMessages) {
        let count = selectedChatMessages.length;
        console.debug('selectedChatMessages count', count, 'this.selectedReceiver', !!this.selectedReceiver);
        return {
          totalMessagesCount: selectedChatMessages.length,
          messages: selectedChatMessages,
        };
      }
      return { totalMessagesCount: 0, messages: [] };
    },
    moduleConfig() {
      return this.getModuleConfig(this.$route.meta.moduleType, this.$route.params.instance);
    },
    messages() {
      return this.selectedChatMessages.messages;
    },
    selectedReceiver: {
      // getter
      get() {
        return this.$store.state.messaging.selectedReceiver;
      },
      // setter
      set(value) {
        const isChanged = JSON.stringify(this.$store.state.messaging.selectedReceiver) !== JSON.stringify(value);
        if (isChanged) {
          this.$store.commit('messaging/setSelectedReceiver', value);
        }
      },
    },
    canUserReceiveMessage() {
      if (this.selectedReceiver.can_receive_messages !== undefined) {
        return Boolean(this.selectedReceiver.can_receive_messages);
      }

      return true;
    },
  },

  methods: {
    ...mapMutations('messaging', ['setMessagesByUserIdUnreadCount', 'setMessagesByGroupIdUnreadCount']),
    ...mapActions('messaging', ['markMessageAsRead']),
    clearChosenFile() {
      if (this.chosenFileUrl) {
        URL.revokeObjectURL(this.chosenFileUrl);
        this.chosenFileUrl = null;
      }
      this.chosenFile = null;
    },
    scrollToStart() {
      this.$nextTick(() => {
        let firstDivider = this.$refs['nav-btn-grp'];
        if (firstDivider) firstDivider.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      });
    },

    scrollToLatestMessage(delay = 10) {
      setTimeout(() => {
        const lastDivider = this.$refs.lastDivider;
        const firstDivider = this.$refs.firstDivider;

        if (lastDivider) {
          if (this.scrollToLatest) {
            lastDivider.scrollIntoView();
          } else {
            firstDivider.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, delay);
    },

    async onReceiverSelected(receiver) {
      console.debug('onReceiverSelected', receiver);
      let messages;
      if (!receiver) return;

      setTimeout(() => {
        if (receiver.userId) {
          messages = this.messagesByUserId[receiver.userId];
          this.setMessagesByUserIdUnreadCount({ userId: receiver.userId, unreadCount: 0 });
        } else {
          messages = this.messagesByGroupId[receiver.groupId];
          this.setMessagesByGroupIdUnreadCount({ groupId: receiver.groupId, unreadCount: 0 });
        }

        let messagesToMark = messages.filter((m) => {
          return messagingUtil.isNotRead(m, this.userId);
        });
        messagesToMark.forEach((m) => {
          if (m) this.markMessageAsRead(m);
        });
      }, 3000);

      this.mx_isLeftDrawerOpen = false;

      this.scrollToLatestMessage();
    },

    async sendMessage() {
      console.debug('sendMessage', this.message);
      this.$store.dispatch('messaging/sendChatMessage', {
        receiver: this.selectedReceiver,
        isGroup: this.selectedReceiver.groupId ? true : false,
        text: this.message,
        base64Image: this.chosenImageBase64,
        file: this.chosenFile,
      });

      this.chosenImageBase64 = null;
      this.clearChosenFile();
      this.chosenFile = null;
      this.message = null;
      this.displayConversations = true;
    },

    onAttachmentClick() {
      // Use $refs for a more Vue-like approach
      if (this.$refs.attachmentPicker && this.$refs.attachmentPicker.$refs.input) {
        this.$refs.attachmentPicker.$refs.input.click();
      }
    },

    async onPickAttachment(file) {
      this.clearChosenFile();
      if (file) {
        // A file was chosen, so clear any image
        this.chosenImageBase64 = null;
        this.chosenImage = null;
        this.chosenFile = file;
        this.chosenFileUrl = URL.createObjectURL(file);
      }
    },

    async onPickImage(image) {
      this.clearChosenFile();
      if (image && image.type.substring(0, 6) === 'image/') {
        this.chosenFile = null;
        let base64Image = await preprocessImage(image);
        console.debug('base64Image', base64Image);
        this.chosenImageBase64 = base64Image;
      }
    },
    onCameraClick() {
      // trigger hidden upload field (does not work with $refs.imagePicker)
      // this.$refs['imagePicker'].click();
      if (this.$refs.cameraPicker && this.$refs.cameraPicker.$refs.input) {
        this.$refs.cameraPicker.$refs.input.click();
      }
    },
    onImageClick() {
      if (this.$refs.imagePicker && this.$refs.imagePicker.$refs.input) {
        this.$refs.imagePicker.$refs.input.click();
      }
    },
    markAsReadAfterTimeout(messages) {
      if (messages) {
        setTimeout(() => {
          messages
            .filter((m) => messagingUtil.isNotRead(m, this.userId))
            .forEach((m) => {
              console.debug('mark message', m.text, 'as read');
              this.markMessageAsRead(m);
            });
          let receiver = this.selectedReceiver;
          if (receiver) {
            if (receiver.userId) {
              this.setMessagesByUserIdUnreadCount({ userId: receiver.userId, unreadCount: 0 });
            } else {
              this.setMessagesByGroupIdUnreadCount({ groupId: receiver.groupId, unreadCount: 0 });
            }
          }
        }, 4000);
      }
    },
  },
  watch: {
    /**
     * Watcher is used in case a thread (conversation) is open and a message
     * @param newValue
     * @param oldValue
     */
    messages(newValue, oldValue) {
      if (newValue) {
        this.markAsReadAfterTimeout();
      }
      if (Array.isArray(newValue) && Array.isArray(oldValue)) {
        if (newValue.length > oldValue.length) {
          this.scrollToLatestMessage();
        }
      }
    },
  },
  beforeDestroy() {
    // Clean up the object URL to prevent memory leaks
    if (this.chosenFileUrl) {
      URL.revokeObjectURL(this.chosenFileUrl);
    }
  },
};
</script>
<style scoped>
.messages-container-light {
  background: #f0f0f0;
}

.messages-container-dark {
  background: #202020;
}

.messages {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.messages::-webkit-scrollbar {
  display: unset !important;
}

/* width */
.messages::-webkit-scrollbar {
  width: 6px;
}

/* Track */
.messages::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 8px !important;
}

/* Handle */
.messages::-webkit-scrollbar-thumb {
  background: #a0a0a0 !important;
  border-radius: 3px !important;
}

/* Handle on hover */
.messages::-webkit-scrollbar-thumb:hover {
  background: rgb(58, 58, 60) !important;
}

.fixed-footer {
  position: relative;
  z-index: 10000;
  width: calc(100% - 16px) !important;
  left: 0;
  bottom: 45px;
  height: 45px;
  background: white;
}

.nav-btn-grp {
  display: flex;
  justify-content: center;
  transform: translateY(-20px);
}

.nav-btn-light {
  color: #a0a0a0;
  border: 1px solid #f0f0f0;
  background: white;
}

.nav-btn-dark {
  color: #a0a0a0;
  border: 1px solid #101010;
  background: #303030;
}

.nav-btn-1,
.nav-btn-2,
.nav-btn-3 {
  z-index: 100000;

  border-radius: 20px;
}

.nav-btn-1 {
  height: 30px;
  /* transform: translateX(calc(50% - 50px)) translateY(-30px) !important; */
}

.nav-btn-2 {
  /* transform:translateX(50% + 50px) translateY(-60px) !important; */
}

.nav-btn-3 {
  transform: translateX(10px) translateY(-50px) !important;
}
</style>
<style>
/** Corrects input field height */
.message-input .v-input__control {
  /* height: 50px !important; */
}

textarea {
  margin-bottom: 20px !important;
}
</style>
